import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import {
	BaasicInput,
	BaasicSelect,
	Loader,
	BaasicCheckbox,
	SliderCheckBox,
	BaasicTab,
	BaasicConfirmModal,
	BaasicDropdown,
} from 'core/components';
import { translate } from 'core/utils';
import { defaultTemplate } from 'core/hoc';
import { carrierTypes, getStampsOAuthUrl, getUpsOAuthUrl } from 'common/constants';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import BasicRadio from 'themes/components/forms/BasicRadio';
import { ButtonAndLink } from 'common/utils';
import { observer } from 'mobx-react';

const CarrierEditTemplate = ({
	t,
	carrierEditViewStore,
	carrierEditViewStore: {
		form,
		loading,
		carrierTypeOptions,
		onSelectChange,
		onSelectSeller,
		carrierTypeDisabled,
		modalTitle,
		isThirdParty,
		onToggleThirdParty,
		isPartialThirdParty,
		shippingAccountOptions,
		isPartialThirdPartyCheck,
		sellerOptions,
		isSuperAdminOrganization,
		isEditMode,
		onAuthorizeStamps,
		authorizedOAuthConfirmModal,
		authorizedOAuthConfirmModalUps,
		isAuthorized,
		warehouseDropdownStore,
		validateCredentials,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<BaasicConfirmModal modalParams={authorizedOAuthConfirmModal} />
			<BaasicConfirmModal modalParams={authorizedOAuthConfirmModalUps} />
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<ReactTooltip className="w--230"></ReactTooltip>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t(modalTitle)}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="spc--bottom--sml">
						<ButtonGroup className="k-button-group--carrier">
							<Button
								togglable={true}
								selected={!isThirdParty}
								onClick={() => onToggleThirdParty(false)}
								type="button"
								icon="icon icon--package"
							>
								<BasicRadio
									field={form.$('isCarrier')}
									value={!isThirdParty}
									name="isThirdParty"
									label={'CARRIERVIEW.CARRIER'}
									className="input--radio"
								></BasicRadio>
							</Button>
							<Button
								togglable={true}
								selected={isThirdParty}
								onClick={() => onToggleThirdParty(true)}
								type="button"
								icon="icon icon--third-party-carrier"
							>
								<BasicRadio
									field={form.$('isThirdParty')}
									value={isThirdParty}
									name="isThirdParty"
									label={'CARRIERVIEW.ISTHIRDPARTYCARRIER'}
									className="input--radio"
								></BasicRadio>
							</Button>
						</ButtonGroup>
					</div>
					{isSuperAdminOrganization && !isEditMode && (
						<div className="inputgroup spc--bottom--sml">
							<BaasicSelect
								field={form.$('seller')}
								clearable={false}
								options={sellerOptions}
								value={form.$('seller').value}
								onChange={value => onSelectSeller(value, form.$('seller'), false)}
							/>
						</div>
					)}
					<BaasicInput field={form.$('name')} />

					{(!isThirdParty || (isThirdParty && !isPartialThirdParty)) && (
						<div className="inputgroup spc--bottom--sml">
							<BaasicSelect
								field={form.$('carrierType')}
								clearable={false}
								options={carrierTypeOptions}
								value={form.$('carrierType').value}
								onChange={value => onSelectChange(value, form.$('carrierType'), true)}
								isDisabled={carrierTypeDisabled}
							/>
						</div>
					)}

					<div className="inputgroup spc--bottom--sml">
						<BaasicDropdown
							dropdownStore={warehouseDropdownStore}
							placeholder={t('PLACEHOLDER.WAREHOUSE')}
							additionalLabel={() => (
								<i data-tip={t('CARRIERVIEW.WAREHOUSESINFO')} className="fas fa-exclamation-circle"></i>
							)}
						/>
					</div>

					<div className="spc--bottom--sml">
						<div className="flex--primary spc--bottom--sml">
							<h4 className="spc--right--tny" htmlFor="">
								{t('CARRIERVIEW.SURPLUSCHARGE')}
							</h4>
							<i data-tip={t('CARRIERVIEW.SURPLUSCHARGEINFO')} className="fas fa-exclamation-circle"></i>
						</div>
						<div className="form--surplus">
							<div className="form--surplus__input">
								<BaasicInput
									field={form.$('surplusCharge')}
									placeholder={form.$('isPercentage').value ? '0' : '0.00'}
								/>
								{form.$('isPercentage').value ? (
									<p className="form--surplus__input__value">%</p>
								) : (
									<p className="form--surplus__input__value">$</p>
								)}
							</div>
							<div className="form--surplus__toggle">
								<SliderCheckBox field={form.$('isPercentage')} />
							</div>
						</div>
					</div>

					{isThirdParty && (
						<div className="row spc--bottom--sml">
							<div className="col col-sml-10">
								<BaasicCheckbox
									id={form.$('isPartialThirdParty').id}
									onChange={event => isPartialThirdPartyCheck(event, form.$('isPartialThirdParty'))}
									label="CARRIERVIEW.ISPARTIALTHIRDPARTY"
									checked={form.$('isPartialThirdParty').value}
								/>
							</div>
						</div>
					)}
					{(form.$('carrierType').value != '' || isPartialThirdParty) && (
						<React.Fragment>
							{!isPartialThirdParty && form.$('carrierType').value.label !== carrierTypes.stamps && (
								<h4 className="spc--bottom--sml">{t('CARRIERVIEW.CREDENTIALS')}</h4>
							)}

							{/* UPS template. New */}
							{!isPartialThirdParty && form.$('carrierType').value.label === carrierTypes.ups && (
								<UpsTemplate viewStore={carrierEditViewStore} />
							)}

							{(!isPartialThirdParty || !isThirdParty) &&
								form.$('carrierType').value.label === carrierTypes.fedex &&
								form.$('fedex').map(field => {
									return (
										<div key={field.id}>
											<BaasicInput field={field} />
										</div>
									);
								})}

							{/* Stamps authorization */}
							{!isEditMode && form.$('carrierType').value.label === carrierTypes.stamps && (
								<ButtonAndLink
									field={form.$('stamps.isAuthorized')}
									value={form.$('stamps.isAuthorized').value}
									label={t('CARRIERVIEW.AUTHORIZE')}
									btnClass="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
									url={getStampsOAuthUrl()}
									onClick={() => onAuthorizeStamps()}
									disabled={isAuthorized}
								/>
							)}

							{isThirdParty && isPartialThirdParty && (
								<div className="inputgroup spc--bottom--sml">
									<BaasicSelect
										field={form.$('shippingAccount')}
										clearable={false}
										options={shippingAccountOptions}
										value={form.$('shippingAccount').value}
										onChange={value => onSelectChange(value, form.$('shippingAccount'))}
										disabled={isSuperAdminOrganization && form.$('seller').isEmpty && !isEditMode}
									/>
								</div>
							)}
							{isThirdParty && isPartialThirdParty && (
								<BaasicInput field={form.$('thirdPartyBilling.billToAccountNumber')} />
							)}
							{isThirdParty && isPartialThirdParty && (
								<BaasicInput field={form.$('thirdPartyBilling.billToAccountZip')} />
							)}
						</React.Fragment>
					)}
					{form.error && (
						<React.Fragment>
							<p className="type--color--warning spc--bottom--sml">{translate(form.error)}</p>
						</React.Fragment>
					)}
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
						type="submit"
						disabled={loading}
					>
						{loading ? (
							<div className="spinnercont spc--right--sml">
								<div className="spinner"></div>
							</div>
						) : null}
						{t('SAVE')}
					</button>
					<button
						className="btn btn--med btn--primary spc--bottom--sml"
						type="button"
						disabled={
							(!form.$('carrierType').value && !form.$('shippingAccount').value) ||
							(form.$('carrierType').value && form.$('carrierType').value.label === carrierTypes.ups) ||
							(form.$('shippingAccount').value &&
								form.$('shippingAccount').value.extra.carrierType &&
								form.$('shippingAccount').value.extra.carrierType.name === carrierTypes.ups)
						}
						onClick={validateCredentials}
						data-tip={
							form.$('carrierType').value.label === carrierTypes.ups ||
							(form.$('shippingAccount').value &&
								form.$('shippingAccount').value.extra.carrierType &&
								form.$('shippingAccount').value.extra.carrierType.name === carrierTypes.ups)
								? translate('CARRIERVIEW.UPSNOTAVAILABLE')
								: ''
						}
					>
						{t('CARRIERVIEW.TESTCONNECTION')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(CarrierEditTemplate);

const UpsTemplate = observer(
	({
		viewStore: {
			form,
			isPartialThirdParty,
			isThirdParty,
			onAuthorizeUps,
			isAuthorized,
			isExternalAccount,
			setIsExternalAccount,
		},
	}) => {
		if (isExternalAccount) {
			form.$('ups.clientId').set('rules', 'required');
			form.$('ups.clientSecret').set('rules', 'required');
			form.$('ups.shipperNumber').set('rules', 'required');
			form.$('ups.refreshToken').set('rules', '');
			form.$('ups').set('rules', '');
		} else {
			form.$('ups.clientId').set('rules', '');
			form.$('ups.clientSecret').set('rules', '');
			form.$('ups.shipperNumber').set('rules', 'required');
			form.$('ups.refreshToken').set('rules', 'required');
			form.$('ups').set('rules', 'authorize');
		}

		return (
			<div>
				<ButtonGroup className="k-button-group--primary">
					<Button
						type="button"
						className="btn btn--sml"
						togglable={true}
						selected={!isExternalAccount}
						onClick={() => setIsExternalAccount(false)}
					>
						{translate('CARRIERVIEW.UPS.SCANSHIPACCOUNT')}
					</Button>
					<Button
						type="button"
						className="btn btn--sml"
						togglable={true}
						selected={isExternalAccount}
						onClick={() => setIsExternalAccount(true)}
					>
						{translate('CARRIERVIEW.UPS.EXTERNALACCOUNT')}
					</Button>
				</ButtonGroup>

				<React.Fragment>
					<BaasicInput field={form.$('ups.accessLicenseNumber')} />
					<BaasicInput field={form.$('ups.shipperNumber')} />
				</React.Fragment>

				{(!isPartialThirdParty || !isThirdParty) &&
					form.$('carrierType').value.label === carrierTypes.ups &&
					isExternalAccount && (
						<React.Fragment>
							<BaasicInput field={form.$('ups.clientId')} />
							<BaasicInput field={form.$('ups.clientSecret')} />
						</React.Fragment>
					)}

				{!isExternalAccount && !isPartialThirdParty && (
					<React.Fragment>
						<BaasicInput field={form.$('ups.refreshToken')} />
						<ButtonAndLink
							field={form.$('ups.isAuthorized')}
							value={form.$('ups.isAuthorized').value}
							label={translate('CARRIERVIEW.AUTHORIZE')}
							btnClass="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
							url={getUpsOAuthUrl()}
							onClick={() => onAuthorizeUps()}
							disabled={isAuthorized}
						/>
					</React.Fragment>
				)}
			</div>
		);
	}
);



// WEBPACK FOOTER //
// ./src/themes/default/modules/carrier/pages/CarrierEditTemplate.jsx